import React from "react"

import Report from "pages/admin/partnerConnections/Report"

/**
 * Подключения в партнёрском кабинете.
 *
 * Экран тот же, что в админке, но по своей ветке: партнёр видит подключения,
 * которые сделал сам, и подключения своих подчинённых. Ветку режет бэк по
 * логину из токена — отдельного фильтра «чьи показывать» здесь нет.
 */
function Index() {
	return (
		<Report
			url="/partner/connections"
			billingUrl="/partner/connections/billing"
			title="Подключения" />
	)
}

export default Index
